import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CopyIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M17 3H5a2 2 0 0 0-2 2v14h2V5h12V3Z" /><path d="M7 8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8Z" />
    </SvgIcon>
);
